/* GG · Global · Header — mega-menu + scroll behaviour.
   Homepage (overlay): header lies transparent over the hero and scrolls away
   with the page; scrolling up pins a SOLID header at the top (instantly);
   back at the very top it turns transparent again.
   Inner pages: normal sticky header, hides on scroll-down, shows on scroll-up.
   Cart icon keeps id #cart-icon-bubble so cart-drawer.js opens the drawer. */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-gg-header]');
    if (!header) return;

    var toggle = header.querySelector('[data-gg-menu-toggle]');
    var menu = header.querySelector('[data-gg-menu]');
    var root = document.documentElement;
    var isOverlay = header.classList.contains('gg-header--overlay');
    var annoH = 0;
    var lastY = window.scrollY || 0;
    var upAccum = 0;
    var ticking = false;

    /* Announcement height → where the absolute overlay header sits at the top */
    function measure() {
      var anno = document.querySelector('.gg-announce-wrap');
      annoH = anno ? Math.round(anno.getBoundingClientRect().height) : 0;
      root.style.setProperty('--gg-anno-h', annoH + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    /* ---- Search dropdown ---- */
    var searchToggle = header.querySelector('[data-gg-search-toggle]');
    var searchPanel = header.querySelector('[data-gg-search]');
    function openSearch() {
      header.classList.add('is-search-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel && searchPanel.querySelector('[data-gg-search-input]');
      /* Der Fokus MUSS synchron im Klick-Task passieren. iOS Safari oeffnet die
         Tastatur nur, wenn focus() direkt aus der Nutzergeste kommt — der
         frueher hier stehende setTimeout(60) war zwar sichtbar fokussiert, aber
         die Tastatur blieb zu. Die Klasse ist eine Zeile vorher gesetzt, das
         Feld also bereits sichtbar und fokussierbar. Der Timeout bleibt als
         zweiter Versuch fuer Browser, die nach dem Layout neu fokussieren. */
      if (input) {
        try { input.focus({ preventScroll: true }); } catch (e) {
          try { input.focus(); } catch (e2) {}
        }
        setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 60);
      }
    }
    function closeSearch() {
      header.classList.remove('is-search-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        if (header.classList.contains('is-search-open')) { closeSearch(); }
        else { if (header.classList.contains('is-open')) close(); openSearch(); }
      });
      searchPanel.querySelectorAll('[data-gg-search-close]').forEach(function (el) {
        el.addEventListener('click', closeSearch);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
      document.addEventListener('click', function (e) {
        if (header.classList.contains('is-search-open') && !header.contains(e.target)) closeSearch();
      });
    }

    /* ---- Menu open / close ---- */
    function open() {
      header.classList.add('is-open');
      header.classList.remove('is-top', 'is-hidden', 'is-search-open');
      if (menu) menu.setAttribute('aria-hidden', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('gg-menu-locked');
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      header.classList.remove('is-open');
      if (menu) menu.setAttribute('aria-hidden', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('gg-menu-locked');
      document.removeEventListener('keydown', onKeydown);
      lastY = window.scrollY || 0;
      applyScrollState(lastY);
    }
    function onKeydown(e) { if (e.key === 'Escape') close(); }

    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        header.classList.contains('is-open') ? close() : open();
      });
      header.querySelectorAll('[data-gg-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
      header.querySelectorAll('[data-gg-menu-link]').forEach(function (el) { el.addEventListener('click', close); });
    }

    /* ---- Category tabs ---- */
    var tabs = Array.prototype.slice.call(header.querySelectorAll('[data-gg-tab]'));
    var panels = Array.prototype.slice.call(header.querySelectorAll('[data-gg-panel]'));
    function activate(index) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-gg-tab') === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-gg-panel') === String(index);
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      if (menu && menu.scrollTo) menu.scrollTo({ top: 0 });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-gg-tab'));
        tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });
    });

    /* ---- Scroll behaviour ---- */
    function pin() {
      if (header.classList.contains('is-pinned')) {
        header.classList.remove('is-hidden');
        return;
      }
      // enter pinned hidden, then reveal on the next frame → slides in
      header.classList.add('is-pinned', 'is-hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { header.classList.remove('is-hidden'); });
      });
    }

    function applyScrollState(y) {
      if (header.classList.contains('is-open')) return;

      if (isOverlay) {
        if (y <= annoH + 6) {
          // at the very top → transparent, absolute, not pinned
          header.classList.add('is-top');
          header.classList.remove('is-pinned', 'is-hidden');
          upAccum = 0;
        } else if (y > lastY) {
          // scrolling DOWN
          upAccum = 0;
          if (header.classList.contains('is-pinned')) {
            header.classList.add('is-hidden');        // slide the solid header out
          } else {
            header.classList.add('is-top');           // stay transparent → scrolls away (no early solid)
            header.classList.remove('is-hidden');
          }
        } else if (y < lastY) {
          // scrolling UP — pin solid only after a little upward travel & past the hero top
          upAccum += (lastY - y);
          if (upAccum > 10 && y > annoH + 60) {
            header.classList.remove('is-top');
            pin();
          }
        }
      } else {
        if (y <= 4) { header.classList.remove('is-hidden'); }
        else if (y > lastY && y > 100) { header.classList.add('is-hidden'); }
        else if (y < lastY) { header.classList.remove('is-hidden'); }
      }
    }

    applyScrollState(lastY);
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        applyScrollState(y);
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
